import React, { useState } from "react";
import logo from "../../../../../../../assets/logos/golden-logo.png";
import Button from "../../../../../../common/Button/Button";
import InputFormik from "../../../../../../common/Formik/Input/InputFormik";
import Select from "../../../../../../common/Formik/Select/Select";
import styles from "./Buy.module.scss";
import BuyConfirm from "../../../../../../common/Modals/BuyConfirm/BuyConfirm";
import { useSelector } from "react-redux";
import silver from "../../../../../../../assets/logos/silver-logo.png";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  Messages,
  FORMIK_REGEX,
  STATUS_CODE,
} from "../../../../../../../utils/constants";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Form } from "react-bootstrap";
import {
  createBuyOrderAction,
  getSpotPriceAction,
  getUserCoinListAction,
  getWalletBalanceAction,
} from "../../../../../../../features/user/userSlice";
import { formatPrice, toFix } from "../../../../../../../utils/utils";
import { validationMessage } from "../../../../../../../Helper/helperfunction";
import PaymentCompleted from "../../../../../../common/Modals/PaymentCompleted/PaymentCompleted";

const Buy = () => {
  const dispatch = useDispatch();
  const kycStatus = useSelector(
    (state) => state?.persist?.userInfo?.kyc_status
  );
  const userData = useSelector((state) => state?.persist?.userInfo);
  const walletBalance = useSelector(
    (state) => state?.users?.commonWalletBalance.amount
  );

  const [show, setShow] = useState(false);
  const [total, setTotal] = useState(0);
  const [showCompleted, setShowCompleted] = useState(false);
  const [paymentType, setPaymentType] = useState("STRIPE");
  const assetOptions = [
    {
      label: "Gold STBL",
      icon: logo,
      value: 1,
      symbol: "XAU/USD",
    },
    {
      label: "Silver STBL",
      icon: silver,
      value: 2,
      symbol: "XAG/USD",
    },
  ];
  const [tokenObj, setTokenObj] = useState(assetOptions[0]);
  const [decimalLimit, setDecimalLimit] = useState();

  const buyValidationSchema = Yup.object({
    quantity: Yup.string()
      .required(validationMessage("Quantity"))
      .matches(FORMIK_REGEX.NONZERODECIMAL, Messages?.NONZERODECIMALVALIDATION),
    amount: Yup.string()
      .required(validationMessage("Amount"))
      .matches(FORMIK_REGEX.NONZERODECIMAL, Messages?.NONZERODECIMALVALIDATION),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      quantity: "",
      amount: "",
      tokenId: assetOptions[0].value,
      tokenName: assetOptions[0].label,
      orderType: "BUY",
      type: "STRIPE",
      price: "",
    },
    validationSchema: buyValidationSchema,
    onSubmit: async (values) => {
      setShow(true);
    },
  });

  const getSpotPrice = async (data) => {
    try {
      const params = {
        symbol: tokenObj?.symbol,
      };
      const response = await dispatch(getSpotPriceAction(params));
      if (response.status === 200) {
        formik.setFieldValue("amount", response?.data?.data?.Ask);
        formik.setFieldValue("price", response?.data?.data?.Ask);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    formik.setFieldValue("type", paymentType);
  }, [paymentType]);
  const handleBuyConfirm = async () => {
    try {
      const response = await dispatch(createBuyOrderAction(formik.values));
      if (response.status === 200) {

        // Partnero Transaction Tracking
        if (window.po && typeof window.po === "function") {
          console.log("Partero tracking initiated for transaction:", {
            transactionId: response.data.data.transactionId,
            userEmail: userData?.email,
            totalAmount: Number(formik.values.amount),
          });

          try {
            const partneroData = {
              data: {
                key: response.data.data.transactionId, // Transaction ID
                amount: Number(formik.values.amount), // Total amount
                amount_units: "usd", // Currency code
                customer: {
                  key: userData?.email, // User identifier
                },
              },
            };


            window.po("transactions", "create", partneroData);

            
          } catch (error) {
            console.error("Error during Partnero transaction tracking:", {
              error: error.message,
              transactionId: response.data.data.transactionId,
              userEmail: userData?.email,
              totalAmount: Number(formik.values.amount),
            });
          }
        } else {
          console.warn("⚠️ Partnero 'po' function not found on window. Ensure Partnero script is loaded.");
        }

        dispatch(getWalletBalanceAction());
        setShow(false);
        setShowCompleted(true);
        getSpotPrice();
        formik.resetForm({ ...formik.initialValues });
      }
    } catch (error) {
      console.error("Error placing buy order:", {
        error: error.message,
        stack: error.stack,
        formData: JSON.stringify(formik.values, null, 2),
      });
    }
  };

  const handleAssetChange = (selected) => {
    formik.resetForm();
    setTokenObj(selected);
    formik?.setFieldValue("tokenId", selected?.value);
    formik?.setFieldValue("tokenName", selected?.label);
  };

  useEffect(() => {
    getSpotPrice();
    fetchCoinOptions();
  }, [tokenObj]);

  useEffect(() => {
    const total =
      isNaN(formik.values.quantity) || isNaN(formik.values.amount)
        ? 0
        : formik.values.quantity * formik.values.amount;
    setTotal(total.toFixed(2));
  }, [formik.values.quantity, formik.values.amount]);

  const handleQuantityChange = (e) => {
    const filterVal = e.target.value.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
    const value = filterVal;
    const regex = new RegExp(`^\\d*(\\.\\d{0,${decimalLimit}})?$`);
    if (value === "" || regex.test(value)) {
      formik.setFieldValue("quantity", value);
    }
  };

  const fetchCoinOptions = async () => {
    try {
      const response = await dispatch(getUserCoinListAction());
      if (response.data.status === STATUS_CODE.successful) {
        const array = [];
        const newData = response.data.data.coinList;
        const quantityDecimal = newData.find(
          (coin) => coin.coin_symbol === tokenObj?.label
        );
        // console.log("quantityDecimal", quantityDecimal);
        setDecimalLimit(quantityDecimal?.quantity_decimal);
      }
    } catch (error) {
      console.error("Error fetching coin options:", error);
    }
  };

  return (
    <>
      <div className={styles.buy_module}>
        <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
          <div className={`${styles.buy_module_asset} ${styles.mb_7}`}>
            <div className={styles.buy_module_asset_header}>
              <h6 className={styles.select_asset}>Select Asset</h6>
              <h6 className={styles.balance}>
                Wallet Bal: <span>{toFix(Number(walletBalance), 3)}</span>
              </h6>
            </div>
            <Select
              options={assetOptions}
              variant="dark large_height"
              isSearchable={false}
              defaultValue={assetOptions[0]}
              onChange={handleAssetChange}
            />
          </div>
          <div className={`${styles.qty} ${styles.mb_7}`}>
            <InputFormik
              id="quantity"
              name="quantity"
              label="Quantity"
              variant="dark"
              className={styles.qty_input}
              placeholder="100.00"
              formik={formik}
              onChange={handleQuantityChange}
              onBlur={formik.handleBlur}
              value={
                formik.values.quantity ? `${formik.values.quantity} ozt` : ""
              }
              maxLength={10}
            />
          </div>
          <div className={`${styles.amount} ${styles.mb_7}`}>
            <InputFormik
              label="Price (USD)"
              name="amount"
              variant="dark"
              placeholder="100.00"
              className={styles.amount_input}
              formik={formik}
              onChange={(e) => {
                formik.handleChange(e);
                formik.setFieldValue("price", e.target.value);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.amount}
              maxLength={10}
              disabled
            />
          </div>
          <div className={`${styles.total_text} ${styles.mb_16}`}>
            <h6>Total</h6>
            <h4>${total}</h4>
          </div>
          <Button
            type="button"
            variant="secondary_btn"
            fluid
            disabled={kycStatus !== "APPROVED"}
            onClick={(e) => {
              formik.handleSubmit(e);
            }}
          >
            Buy {tokenObj?.label}
          </Button>
        </form>
      </div>
      <BuyConfirm
        show={show}
        buyData={formik.values}
        handleClose={() => setShow(false)}
        handleBuyConfirm={handleBuyConfirm}
        setPaymentType={setPaymentType}
        title={`Buy ${tokenObj?.label} for USD`}
      />
      <PaymentCompleted
        show={showCompleted}
        handleClose={() => setShowCompleted(false)}
        paymentType="BUY"
      />
    </>
  );
};

export default Buy;
